
const dateFns = require("date-fns");
Object.assign(global, dateFns);
const today = new Date();
const date = dateFns.formatISO(today, { representation: "date" });
const noStartDates = () => [];
export const startDateGenerators = {oneTime: noStartDates, weekly: noStartDates, fortnightly: noStartDates, fourWeekly: noStartDates, monthly: noStartDates, quarterly: noStartDates, halfYearly: noStartDates, annual: noStartDates};
